import { useLocation, Link } from "react-router-dom";
import { Breadcrumb as AntBreadcrumb } from "antd";
import { FaHome } from "react-icons/fa";
import { generateBreadcrumbs } from "@/frontend/utils";

export function Breadcrumb() {
  const location = useLocation();
  const breadcrumbs = generateBreadcrumbs(location.pathname);

  return (
    <div className="mb-4 bg-white rounded-lg px-4 py-3 shadow-sm border border-gray-200">
      <AntBreadcrumb
        className="[&_.ant-breadcrumb-link]:text-gray-600 [&_.ant-breadcrumb-link]:hover:text-primary [&_.ant-breadcrumb-link]:transition-colors [&_.ant-breadcrumb-separator]:text-gray-400 [&_.ant-breadcrumb-link]:font-medium"
        items={breadcrumbs.map((item, index) => ({
          title:
            index === 0 ? (
              <Link
                to={item.path || "/dashboard"}
                className="   text-gray-700 hover:text-primary transition-colors font-medium"
              >
                <div className="flex items-center gap-2">
                  <FaHome className="text-sm" />
                  <span>{item.title}</span>
                </div>
              </Link>
            ) : item.path ? (
              <Link
                to={item.path}
                className="text-gray-600 hover:text-primary transition-colors font-medium"
              >
                {item.title}
              </Link>
            ) : (
              <span className="text-gray-900 font-semibold">{item.title}</span>
            ),
        }))}
      />
    </div>
  );
}
